/**
 * Утилиты для работы с DOM-элементами в VROC системе
 */
export class DomUtils {
	/**
	 * Генерирует точный DOM-селектор для элемента (тег + id + классы)
	 * @param {HTMLElement} element - DOM элемент
	 * @returns {string} - DOM селектор
	 */
	static generateDomSelector(element) {
		let selector = element.tagName.toLowerCase();

		// Добавляем ID, если есть
		if (element.id) {
			selector += `#${element.id}`;
		}

		// Добавляем классы, если есть (сортируем для стабильности)
		if (element.className) {
			const classes = element.className.trim().split(/\s+/).filter(cls => cls).sort();
			if (classes.length > 0) {
				selector += '.' + classes.join('.');
			}
		}

		return selector;
	}

	/**
	 * Находит элемент среди кандидатов по точному DOM-селектору
	 * @param {HTMLElement} originalElement - Оригинальный элемент
	 * @param {NodeList|Array} candidates - Кандидаты для поиска
	 * @returns {HTMLElement|null} - Найденный элемент или null
	 */
	static findByDomSelector(originalElement, candidates) {
		const originalSelector = this.generateDomSelector(originalElement);

		// Ищем среди кандидатов элемент с точно таким же DOM-селектором
		for (const candidate of candidates) {
			const candidateSelector = this.generateDomSelector(candidate);
			if (originalSelector === candidateSelector) {
				return candidate;
			}
		}

		return null;
	}

	/**
	 * Получает уникальный идентификатор элемента (только id)
	 * @param {HTMLElement} element - DOM элемент
	 * @returns {string|null} - CSS селектор или null
	 */
	static getUniqueIdentifier(element) {
		// Проверяем только ID - это самый надежный уникальный идентификатор
		if (element.id) {
			return `#${element.id}`;
		}

		return null;
	}

	/**
	 * Получает относительный CSS путь к элементу
	 * @param {HTMLElement} element - DOM элемент
	 * @param {HTMLElement} container - Контейнер компонента
	 * @returns {string|null} - CSS селектор или null
	 */
	static getRelativePath(element, container) {
		const path = [];
		let current = element;

		while (current && current !== container) {
			let selector = current.tagName.toLowerCase();

			// Добавляем классы
			if (current.className) {
				const classes = current.className.trim().split(/\s+/).filter(cls => cls);
				if (classes.length > 0) {
					selector += '.' + classes.join('.');
				}
			}

			// Добавляем ID если есть
			if (current.id) {
				selector += `#${current.id}`;
			}

			path.unshift(selector);
			current = current.parentElement;
		}

		return path.length > 0 ? path.join(' > ') : null;
	}
}
